import type { FaireProductEntity } from "../../entity_types/product";

export const p_pnk8rrtj6h: FaireProductEntity = {
  token: "p_pnk8rrtj6h",
  type: "product",
  name: "Bamburi Large Bowl",
  brandToken: "b_6jbk8zuc",
  brandName: "Amsha",
  imageUrl: "https://cdn.faire.com/fastly/7be48a4fec515ae0e18e0ad59b73d73da1c0a4ae9116557994a371e563c27fca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3ab870cbcb2a1620fd3f35046f3cbae3cd4648be609c564bcaf7dd152dec4e4d.jpeg",
    "https://cdn.faire.com/fastly/5fc63cf52bc4c9d7829773aa218e2ac051962f60ff30c96069e03781362d276b.jpeg"
  ],
  priceDollars: 30,
  description: "This 12\" woven bowl is handmade by our artisans in Rwanda. Made from raffia, banana bark, and sweetgrass, it comes with a string attached to the back so that you can hang it on the wall. In addition to making a beautiful table display, these baskets can also be hung as wall art. You can combine them with other baskets or works of art to make a collage display.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:18.350Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
